import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import logo from "../../assets/hcc-icon-orange.png";

import { signOutUser } from "../../utils/firebase-utils";

import "./nav-bar.styles.css";
import Button from "../form-components/button";
import { PrayerModalContext } from "../../contexts/prayer-modal-context";
import { SignUpModalContext } from "../../contexts/signup-modal-context";
import { SignInModalContext } from "../../contexts/signin-modal-context";
import { ForgottenPasswordContext } from "../../contexts/forgotten-password-context";

const NavBar = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const { openSignInModal, setOpenSignInModal } =
    useContext(SignInModalContext);
  const { setOpenSignUpModal } = useContext(SignUpModalContext);
  const { setOpenSubmitPrayerModal } = useContext(PrayerModalContext);
  const { setOpenForgottenPasswordModal } = useContext(
    ForgottenPasswordContext
  );

  const ref = useRef();

  useEffect(() => {
    const checkIfClickedOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpenMenu(false);
      }
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [setOpenMenu]);

  const navigate = useNavigate();

  const storageUser = localStorage.getItem("user");
  const parsedStorageUser = JSON.parse(storageUser);

  const shouldShowSignUpAndSignIn =
    parsedStorageUser?.isAnonymous === true ? true : false;

  const handleNewPrayerClick = () => {
    setOpenSubmitPrayerModal(true);
  };

  const signOutHandler = async () => {
    await signOutUser();
    localStorage.removeItem("user");
    navigate("/prayers");
    setOpenMenu(!openMenu);
  };

  const handleCreateAccountClick = () => {
    setOpenMenu(!openMenu);
    setOpenSignUpModal(true);
  };

  const handleSignInClick = async () => {
    await setOpenSignInModal(true);
    setOpenMenu(!openMenu);
  };

  return (
    <>
      <section className="nav-bar">
        <div className="nav-bar-logo-container">
          <Link to="/">
            <img className="nav-bar-logo" src={logo} alt="Hope City Logo" />
          </Link>
        </div>

        <div className="menu-container" ref={ref}>
          <div
            className="menu-trigger"
            onClick={() => {
              setOpenMenu(!openMenu);
            }}
          >
            {storageUser && !shouldShowSignUpAndSignIn ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="2.6em"
                viewBox="0 0 448 512"
              >
                <g fill="#363832">
                  <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
                </g>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="2.6em"
                viewBox="0 0 448 512"
              >
                <g fill="#363832">
                  <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z" />
                </g>
              </svg>
            )}
          </div>

          <div className={`dropdown-menu ${openMenu ? "active" : "inactive"}`}>
            {shouldShowSignUpAndSignIn && (
              <>
                <div className="dropdown-item">
                  <Button
                    type="button"
                    buttonType="burgerMenu"
                    onClick={handleCreateAccountClick}
                  >
                    CREATE ACCOUNT
                  </Button>
                </div>
                <div className="dropdown-item">
                  <Button
                    type="button"
                    buttonType="burgerMenu"
                    onClick={handleSignInClick}
                  >
                    SIGN IN
                  </Button>
                </div>
              </>
            )}

            {!shouldShowSignUpAndSignIn && (
              <div className="dropdown-item">
                <Button
                  type="button"
                  buttonType="burgerMenu"
                  onClick={signOutHandler}
                >
                  SIGN OUT
                </Button>
              </div>
            )}
          </div>
        </div>

        <div className="nav-bar-links-container">
          <div>
            <div>
              <div>
                <Button
                  type="button"
                  buttonType="navbar"
                  href="/submit"
                  onClick={handleNewPrayerClick}
                >
                  NEW PRAYER
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Outlet />
    </>
  );
};

export default NavBar;
